import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PatientDetailsHeader from '../../../components/Account/PatientDetailsHeader';
import {
  capitaliseFirstLetter,
  getEnumKeyByEnumValue,
} from '../../../helpers/utilityFunctions/utilityFunctions';
import { PassiveParameterType } from '../../../model/passive/passiveParameterType';
import AlertDetailHeader from './AlertDetailHeader';
import AlertDetailsComponent from './AlertDetailsComponent';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    height: '100vh',
    margin: '12px 40px 0px 0px',
    backgroundColor: 'white',
    borderRadius: '40px 40px 0px 10px',
  },
  header: {
    margin: '40px 0px 0px 30px',
    backgroundColor: 'white',
  },
  content: {
    display: 'flex',
    flexFlow: 'column',
    backgroundColor: 'white',
  },
  backButton: {
    width: '40px',
    height: '40px',
  },
  backIcon: {
    transform: 'scale(1.3)',
  },
}));

const AlertDetail: React.FC = () => {
  const classes = useStyles();
  const { patientId, alertType } = useParams();
  const navigate = useNavigate();

  const type = alertType as keyof typeof PassiveParameterType;
  const processedType = getEnumKeyByEnumValue(
    PassiveParameterType,
    capitaliseFirstLetter(type)
  );
  const finalType: PassiveParameterType = PassiveParameterType[processedType!];

  return (
    <Box>
      <PatientDetailsHeader selectedPatientId={patientId} />

      <div className={classes.root}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            color="primary"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon className={classes.backIcon} />
          </IconButton>
        </div>
        <div className={classes.content}>
          <Box sx={{ margin: '0px 40px 40px 40px' }}>
            <AlertDetailHeader patientId={patientId} alertType={type} />
            <AlertDetailsComponent
              patientId={patientId}
              alertType={finalType}
            />
          </Box>
        </div>
      </div>
    </Box>
  );
};

export default AlertDetail;
